<div class="color-wrapper">
  <div>
    <div class="tabs">
      <button class="tab" [ngClass]="{ active: currenttab.templates }" (click)="switchTab('templates')">
        Plantillas ({{ total_templates }})
      </button>
      <button class="tab ms-3 me-3" [ngClass]="{ active: currenttab.default }" (click)="switchTab('default')">
        Por defecto
      </button>
      <button class="tab" [ngClass]="{ active: currenttab.custom }" (click)="switchTab('custom')">Personalizar</button>
    </div>

    <span
      *ngIf="!currenttab.templates"
      title="Click aquí si no te aparece el layer que muestra el mapa"
      class="asbtn"
      (click)="refresh()">
      <i class="fa fa-refresh me-2 mb-2"></i>Recargar layers
    </span>
    <div *ngIf="currenttab.default && master_default_colors.styles.length">
      <app-default
        [master_default_colors]="master_default_colors"
        (refresh)="copyDefaultToCustom($event)"></app-default>
    </div>
    <div *ngIf="currenttab.custom">
      <app-custom
        #custom
        [master_custom_colors]="master_custom_colors"
        (onTemplateCreate)="onCreateTemplate($event)"></app-custom>
    </div>
    <div *ngIf="currenttab.templates">
      <app-colormap-templates
        #templates
        (doApplyTemplate)="onApplyTemplate($event)"
        (doUpdateTemplatesList)="onTemplatesListUpdate($event)"></app-colormap-templates>
    </div>
  </div>
</div>
